<template>
  <b-container fluid id="app">
    <b-row style="text-align: center;">
      <b-col>
        <h1>404 - PAGE NOT FOUND</h1>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
